<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
    persistent
    transition="dialog-transition"
  >
    <template v-slot:activator="{ attrs }">
      <v-btn
        :loading="isloading"
        color="teal"
        icon
        v-bind="attrs"
        @click="OpenConfim"
      >
        <v-icon>fas fa-check-double</v-icon>
      </v-btn>
    </template>
    <v-card color="grey lighten-5">
      <v-card-title class="error white--text" dark>
        Confirm Order:
        <Strong class="black--text mx-2"> {{ Order._id }}</Strong>

        <v-spacer></v-spacer>

        <v-btn text icon @click="close" dark>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class="justify-center">
          <v-col v-show="!next">
            <v-card class="pa-2 grey lighten-4">
              <v-row>
                <v-col cols="8">
                  <BaseTable :header="header" :items="TranList">
                    <template #Title>
                      Total Cost
                      <v-spacer></v-spacer>
                      <BaseCashView isSmall :Balance="TotalCost"></BaseCashView>
                    </template>
                    <template #[`coll.Amount`]="{ row }">
                      <div>
                        {{ row.Amount.toLocaleString() }}
                        <strong>{{ row.AmountType | MoneySigns }}</strong>
                      </div>
                    </template>
                    <template #footer>
                      <!-- <v-divider></v-divider> -->
                      <v-spacer></v-spacer>
                      <h3>
                        Required by Supplier:
                        <strong class="px-2 grey lighten-5 error--text">{{
                          SuppCost.toLocaleString()
                        }}</strong>
                        {{ Order.CashType | MoneySigns }}
                      </h3>
                      <v-spacer></v-spacer>

                      <!-- {{ Order }} -->
                    </template>
                  </BaseTable>
                </v-col>
                <v-col cols="4">
                  <!-- <v-card class="pa-2 grey lighten-4"> -->
                  <!-- <p>{{ UserInfo.CashBase }}</p> -->
                  <missingQty :itemList="itemList"></missingQty>
                  <DiscountItem
                    :hasError="hasError"
                    :itemList="itemList"
                  ></DiscountItem>
                  <v-form ref="convertionForm">
                    <v-text-field
                      name="RateName"
                      :readonly="Order.CashType == UserInfo.CashBase"
                      :disabled="Order.CashType == UserInfo.CashBase"
                      :label="
                        'Rate ' + Order.CashType + ' to ' + UserInfo.CashBase
                      "
                      id="RateID"
                      :rules="[rateRule]"
                      type="number"
                      v-model.number="Convert.rate"
                      outlined
                    ></v-text-field>
                    <!-- <p>{{ Convert.Note }}</p> -->
                    <v-select
                      outlined
                      :rules="[brancRule]"
                      :items="Baranches"
                      item-text="BranchName"
                      item-value="_id"
                      v-model="Convert.branchID"
                      label="To: Branch"
                    ></v-select>
                  </v-form>
                  <!-- </v-card> -->
                </v-col>
              </v-row>
              <v-card-actions>
                <!-- <v-btn @click="next = true" block color="primary" dark
                  >Calculate</v-btn
                > -->
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col v-if="next">
            <SellingPrice
              :rate="Convert.rate"
              :inventory="itemList"
              :costs="TranList"
            ></SellingPrice>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <p v-html="ErrorMsg" class=" error--text"></p>
        <v-spacer></v-spacer>
        <v-btn :loading="CanceltLoad" @click="CancelBTN" color="error" dark>
          <v-icon v-if="!next" left>fas fa-power-off</v-icon>
          <v-icon v-if="next" left>fas fa-angle-double-left</v-icon>
          {{ next ? "Back" : "Cancel" }}
        </v-btn>
        <v-btn :loading="nextLoad" @click="nextBTN" color="teal" dark
          >{{ next ? "Confirm" : "Next" }}
          <v-icon v-if="next" right>fas fa-check-double</v-icon>
          <v-icon v-if="!next" right>fas fa-angle-double-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { tokenMixin } from "@/Mixins/tokenMixins.js";
import { mapGetters } from "vuex";
export default {
  mixins: [tokenMixin],
  components: {
    missingQty: () => import("./MissingQty"),
    DiscountItem: () => import("./discountItem"),
    SellingPrice: () => import("./SellingPrice"),
  },
  props: {
    ReqURL: { type: String, required: true },
    Order: { type: Object, required: true },
    Updated: { type: Function, required: true },
  },
  data() {
    return {
      ErrorMsg: "",
      DiscountError: false,
      nextLoad: false,
      CanceltLoad: false,
      dialog: false,
      next: false,
      isloading: false,
      TranURL: `stock/Ontheway`,
      // BranchUrl: `branches`,
      // Baranches: [],
      itemList: [],
      TranList: [],
      TotalCost: [],
      header: [
        {
          title: "Account",
          value: "Account",
        },
        {
          title: "Name",
          value: "Description",
        },
        {
          title: "Amount",
          value: "Amount",
        },
      ],
      Convert: {
        rate: 1,
        branchID: "",
      },
    };
  },
  computed: {
    ...mapGetters(["UsersToken", "GetBranches"]),
    WatchRate() {
      return this.Convert.rate;
    },
    Baranches() {
      if (this.UsersToken.branchID)
        return this.GetBranches.filter(
          branch => branch._id == this.UsersToken.branchID
        );
      return this.GetBranches.filter(branch => branch.BranchType == "store");
    },
    SuppCost() {
      let total = 0;

      total += this.itemList.reduce((total, item) => {
        return total + item.qty * item.unitPrice - item.Discount;
      }, 0);
      // }

      return total;
    },
  },
  watch: {
    WatchRate(val) {
      this.itemList.forEach(item => {
        item.convertRate = val;
      });
    },
  },
  methods: {
    hasError(err) {
      // console.log(err);
      this.DiscountError = err;
    },

    nextBTN() {
      this.ErrorMsg = "";
      // console.log(this.next);
      // this.Updated(this.Order);
      let NotError =
        !this.next &&
        this.$refs.convertionForm.validate() &&
        !this.DiscountError;
      let ConfirmBTN =
        this.next &&
        this.$refs.convertionForm.validate() &&
        !this.DiscountError;
      if (NotError) {
        this.nextLoad = true;
        // 2s of late loading

        setTimeout(() => {
          this.nextLoad = false;

          this.next = true;
        }, 2000);
      } else if (ConfirmBTN) {
        // console.log("called");
        let { date, time } = this.Current();
        this.nextLoad = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.TranURL + "/confirm",
            data: {
              Convert: this.Convert,
              itemList: this.itemList,
              CostLists: this.TranList,
              OrderCode: this.Order._id,
              date,
              time,
            },
          })
          .then(() => {
            // console.log(val);
            this.Updated(this.Order);
          })
          .catch(err => {
            console.log(err);
            console.log("================from Confirm==================");
            // console.log(err.response);
            if (err.response) this.ErrorMsg = err.response.data;
          })
          .finally(() => {
            this.nextLoad = false;
          });
      }
    },
    CancelBTN() {
      // console.log(this.next);
      this.ErrorMsg = "";
      if (this.next) {
        this.CanceltLoad = true;
        setTimeout(() => {
          this.CanceltLoad = false;
          this.next = false;
        }, 1500);
      } else this.close();
    },

    discountRule(v) {
      return v >= 0 || "Negative Discount is not allowed";
    },

    rateRule(v) {
      if (v == 1 && this.Order.CashType == this.UserInfo.CashBase) return true;
      if (v > 0 && this.Order.CashType !== this.UserInfo.CashBase) return true;

      return "Rate must > 1";
    },
    close() {
      this.dialog = false;
      this.resetValidate();
    },
    brancRule(v) {
      return !!v || "Choose Branch";
    },
    resetValidate() {
      this.Convert.rate = 1;
      this.Convert.discount = 0;
      this.Convert.Note = "";
      this.next = false;
      this.ErrorMsg = "";
      this.$refs.convertionForm.resetValidation();
    },
    GetReqQuery({ url, query }) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenConfim() {
      try {
        this.isloading = true;
        this.itemList = [];
        this.TranList = [];
        this.TotalCost = [];

        let itemsReq = {
          url: this.ReqURL,
          query: { OrderCode: this.Order._id },
        };
        // Transaction Req
        let TransReq = {
          url: `${this.TranURL}/tranGroupBy`,
          query: { Reason: this.Order._id },
        };
        // Order Balance Req
        let BalanceReq = {
          url: `${this.TranURL}/balance`,
          query: { Reason: this.Order._id },
        };
        // let BranchReq = {
        //   url: `${this.BranchUrl}`,
        //   query: {}
        // };
        axios
          .all([
            this.GetReqQuery(itemsReq),
            this.GetReqQuery(TransReq),
            this.GetReqQuery(BalanceReq),
            // this.GetReqQuery(BranchReq)
          ])
          .then(result => {
            this.dialog = true;
            this.isloading = false;
            this.TranList = result[1].data;
            this.TotalCost = result[2].data;
            // this.Baranches = result[3].data;
            this.FillData(result[0].data);
            // console.log(result[0].data);
          })
          .catch(() => {
            // console.log(error);
            //   this.clickedID = "";
            this.isloading = false;
          });
      } catch (error) {
        // console.log(error);
      }
    },
    FillData(val, isUpdate = false) {
      // console.log(val);
      if (isUpdate) this.Updated();
      //   this.itemList = val;
      //   return;
      this.itemList = val.map(item => ({
        OrderCode: item.OrderCode,
        _id: item.ItemID,
        ItemName: item.InvName,
        UnitType: item.UnitType,
        exp: item.exp,
        qty: item.exp,
        cash: this.Order.CashType,
        unitPrice: item.unitPrice,
        unitCost: 0,
        convertRate: 1,
        Discount: 0,
        SellingPrice: 0,
      }));
      // this.itemList = val.reduce((categ, item) => {
      //   if (!categ[item.AccountName])
      //     categ[item.AccountName] = {
      //       categ: item.AccountName,
      //       InvCateg: item.InvCateg,
      //       lists: []
      //     };
      //   categ[item.AccountName].InvCateg = item.InvCateg;
      //   categ[item.AccountName].lists = [
      //     ...(categ[item.AccountName].lists || []),
      //     {
      //       OrderCode: item.OrderCode,
      //       _id: item.ItemID,
      //       ItemName: item.InvName,
      //       UnitType: item.UnitType,
      //       exp: item.exp,
      //       qty: item.exp,
      //       cash: this.Order.CashType,
      //       unitPrice: item.unitPrice,
      //       unitCost: 0,
      //       convertRate: 1,
      //       Discount: 0,
      //       SellingPrice: 0
      //     }
      //   ];
      //   return categ;
      // }, {});
    },
  },
};
</script>
